module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cZ6Mma/tc-custom/9780062029300.jpg?1740302873419",
      "alt": "This image is the cover for the book Island"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Island\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“Gripping . . . Abbott writes evocatively of every phase in his memorable protagonist’s odyssey . . . a convincing, insightful and eminently readable tale.” —")]), _c('i', [_c('b', [_vm._v("Publishers Weekly")])])]), _c('p', [_vm._v("A portrait of Fred Fay follows an outwardly successful but selfish man's descent into alcoholism and failure and his slow, difficult recovery into a wholly new and meaningful life.")]), _c('p', [_vm._v("“Rich in character and language, this is one of those rare novels the reader hates to see come to an end.” —"), _c('i', [_vm._v("Library Journal")])]), _c('p', [_vm._v("“An often penetrating portrait of a troubled individual's desperate search for and avoidance of human intimacy.” —"), _c('i', [_vm._v("Booklist")])]), _c('p', [_vm._v("“Absorbing.” —"), _c('i', [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charles Abbott\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0